/**
 * 写操作对话框：用于新增/编辑等写操作（只读详情用 DetailDrawer）。
 * 覆盖 admin-web-shell:SC-16。
 */
import type { ReactNode } from 'react';
import { DraggableModal, type DraggableModalProps } from './DraggableModal';

export interface EditDialogProps extends Omit<DraggableModalProps, 'children'> {
  /** 表单内容 */
  children: ReactNode;
}

export function EditDialog({ children, ...rest }: EditDialogProps) {
  return <DraggableModal {...rest}>{children}</DraggableModal>;
}
